import isNumber from 'lodash/isNumber';
import lowerCase from 'lodash/lowerCase';
import random from 'lodash/random';
import { SearchParams, SEARCH_CATEGORY_PRIORITY, SEARCH_STRING_KEY, } from '@yme/utils/bloomreach';
import { DID_YOU_MEAN_STRING_KEY } from '@yme/utils/bloomreach/constants';
import { keyCodes } from '@yme/utils/constants';
import { getLatestModelTitle } from '@yme/utils/product';
import { regExpSpecialCharacters } from '@yme/utils/regEx';
import { CATEGORY_STRING_KEY, MIN_SYMBOLS_TO_SEARCH, SUGGESTED_QUERY_PARAMETER } from './constants';
export const highlightText = (fullText = '', textToHighlight = '') => {
    try {
        const textToHighlightModified = textToHighlight.replace(regExpSpecialCharacters, '\\$&');
        const regex = new RegExp(`(${textToHighlightModified})`, 'gi');
        return fullText.replace(regex, '<strong>$1</strong>');
    }
    catch (error) {
        return fullText;
    }
};
export const getSearchResultLinkParams = (query, category) => {
    const params = new URLSearchParams();
    params.set(SearchParams.QUERY, query);
    if (category) {
        params.set(SearchParams.CATEGORY, lowerCase(category));
    }
    return params.toString();
};
export function sortCategoriesByPriority(categories) {
    return categories.sort((a, b) => {
        const nameA = lowerCase(a.name);
        const nameB = lowerCase(b.name);
        const priorityA = SEARCH_CATEGORY_PRIORITY[nameA];
        const priorityB = SEARCH_CATEGORY_PRIORITY[nameB];
        return priorityA - priorityB;
    });
}
export function getCategoryItemMessage(label, inputValue, categoryName, count) {
    return `${label
        .replace(SEARCH_STRING_KEY, `<strong>${inputValue}</strong>`)
        .replace(CATEGORY_STRING_KEY, categoryName)} (${count})`;
}
export function generateRandomDigitNumber() {
    const min = 1000000000000;
    const max = 9999999999999;
    return random(min, max);
}
export function getProductItemTitle(title, is_latest_model, product_year) {
    if (isNumber(is_latest_model) && isNumber(product_year)) {
        return getLatestModelTitle({
            isLatestModel: Boolean(is_latest_model),
            name: title,
            productYear: String(product_year),
        });
    }
    return title;
}
export function getActiveElementUrl(activeElementData, searchResultsPageUrl, trimmedInputValue) {
    if ('url' in activeElementData) {
        return activeElementData.url;
    }
    const query = 'query' in activeElementData ? activeElementData.query : trimmedInputValue;
    const name = 'name' in activeElementData ? activeElementData.name : '';
    return {
        pathname: searchResultsPageUrl,
        search: getSearchResultLinkParams(query, name),
    };
}
export const shouldHandleEvent = ({ eventKey, trimmedInputValue, isShowNoResults, searchHistoryResult, activeElement, }) => {
    const isEnterKeyPressed = eventKey === keyCodes.ENTER;
    const isValidInputLength = trimmedInputValue.length >= MIN_SYMBOLS_TO_SEARCH;
    const isNoResultsHidden = !isShowNoResults;
    const hasSearchHistoryResults = searchHistoryResult.length > 0;
    return ((isEnterKeyPressed && isValidInputLength && isNoResultsHidden) ||
        (isEnterKeyPressed && hasSearchHistoryResults && !isValidInputLength && activeElement > -1));
};
export const getQueryFromUrl = (path) => {
    const url = new URL(path, window.location.origin);
    return url.searchParams.get(SUGGESTED_QUERY_PARAMETER) ?? '';
};
export const isFacetActiveElement = (activeElementData) => {
    return 'name' in activeElementData;
};
export const getQueryFromActiveElementData = (activeElementData, inputValue) => {
    if ('url' in activeElementData) {
        return getQueryFromUrl(activeElementData.url);
    }
    if ('query' in activeElementData) {
        return activeElementData.query;
    }
    return inputValue;
};
export function getDidYouMeanMessage(label = '', searchString, didYouMeanString) {
    return `${label
        .replace(SEARCH_STRING_KEY, `<strong>"${searchString}"</strong>`)
        .replace(DID_YOU_MEAN_STRING_KEY, `<strong>"${didYouMeanString}"</strong>`)}`;
}
